import { IfpLoan } from '@shared/sec-loans'
import { Notification } from '@ui-components/containers/Notification'
import { TightSectionContent } from '@ui-components/containers/TightSectionContent'
import { DataSummaryItem } from '@ui-components/form/DataSummary'
import { IndentedFormFieldContainer } from '@ui-components/global/FormStyling'
import { useIntl } from 'react-intl'

export const OtherDebtorsSection = ({ otherDebtors }: { otherDebtors: Required<IfpLoan>['otherDebtors'] }) => {
  const { formatMessage } = useIntl()
  const otherDebtorsNames = otherDebtors.map((debtor) => debtor.name)
  return (
    <IndentedFormFieldContainer>
      <TightSectionContent>
        <DataSummaryItem
          id={'other-debtors'}
          label={formatMessage({ id: 'loans-assistance-ifp-loans-other-debtors-label' })}
          value={otherDebtorsNames?.join(', ')}
        />
        <Notification
          header={formatMessage({ id: 'loans-assistance-ifp-loans-primary-debtor-responsibility-notification' })}
          status={'info'}
        />
      </TightSectionContent>
    </IndentedFormFieldContainer>
  )
}
